import { z } from "zod";
import { phoneRegex } from "@miplatform/constants";

export const configUserSchema = z.object({
  firstName: z.string().min(1, "First Name is required"),
  lastName: z.string().min(1, "Last Name is required"),
  displayName: z.string().min(1, "Display Name is required"),
  userName: z.string(),
  primaryPhoneNumber: z
    .string()
    .regex(phoneRegex, "Phone number must be numeric and 10 digits")
    .optional()
    .or(z.literal("")),
  email: z.string().min(1, "Email is required").email("Invalid email format"),
  preferredContactMethod: z.enum(["Email", "Phone"], {
    errorMap: () => ({ message: "Preferred Contact Method is required" }),
  }),
  roles: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
        key: z.string().optional(),
      })
    )
    .optional(),
});
